import * as React from 'react';
import StandardSummary from '../StandardSummary/StandardSummary';
const $ = require('jquery');
import './assets/ssViewer.css';
import { StandardSummaryGrouping } from '../StandardSummary/common';
import { toNumber } from 'lodash';

export interface IStandardSummaryViewerProps {
}

export interface IStandardSummaryViewerState {
  loading: boolean;
  db: string;
  month: string;
  year: string;
  quarter: string;
  type: string;
  countyCode: string;
  cityCode: string;
  description: string;
  token: string;
  grouping: string;
  partId: number;
}

const initialState: IStandardSummaryViewerState = {
  loading: false,
  db: '',
  month: '',
  year: '',
  quarter: '',
  type: '',
  countyCode: '',
  cityCode: '',
  description: '',
  token: null,
  grouping: null,
  partId: null,
};

class StandardSummaryViewer extends React.Component<
  IStandardSummaryViewerProps,
  IStandardSummaryViewerState
> {
  public constructor(props: IStandardSummaryViewerProps) {
    super(props);
    this.state = initialState;
  }

  componentDidMount() {
    document.querySelectorAll('style,link[rel="stylesheet"]').forEach((item) => {
      if (!item.textContent.includes("StandardSummaryCss")) {
        item.remove()
      }
    });
    const urlParams = new URLSearchParams(window.location.search);
    this.setState({
      db: urlParams.get('db'),
      month: urlParams.get('m'),
      type: urlParams.get('t'),
      year: urlParams.get('y'),
      quarter: urlParams.get('q'),
      grouping: urlParams.get('grouping'),
      countyCode: urlParams.get('countyCode'),
      cityCode: urlParams.get('cityCode'),
      token: urlParams.get('token'),
      partId: toNumber(urlParams.get('pid')),
    });
  }

  render() {
    return (
      <React.Fragment>
        {this.state.loading ? <div className='divAad'>Loading</div> : (
          <div className='divStandardSummaryViewer'>
            <div>
              {this.state.db && this.state.db.length > 0 && (
                <StandardSummary
                  partId={this.state.partId}
                  ssRequest={
                    {
                      standardSummaryTypeId: parseInt(this.state.type),
                      db: parseInt(this.state.db),
                      month: parseInt(this.state.month),
                      quarter: parseInt(this.state.quarter),
                      year: parseInt(this.state.year),
                      countyCode: this.state.countyCode,
                      cityCode: this.state.cityCode,
                      grouping: this.state.grouping && StandardSummaryGrouping[this.state.grouping],
                    }
                  }
                  apiToken={this.state.token}
                />
              )}
            </div>
          </div>
        )}
      </React.Fragment>
    );
  }
}

export function mapStateToProps(state: any) {
  return {
    currentUser: state.Application.currentUser,
    standardSummaryDatabases: state.StandardSummary.standardSummaryDatabases,
  };
}

const mapDispatchToProps = {
};

export default StandardSummaryViewer;


